import { atom } from "jotai";

import { JoinBooking } from "@/screens/JoinBooking/types";

export const selectedRoundIdAtom = atom<string | null>(null);

export const selectedRoundAtom = atom<JoinBooking.CustomerRound | null>(null);
